import { render, staticRenderFns } from "./MessageListAvatar.vue?vue&type=template&id=766c1862&"
import script from "./MessageListAvatar.vue?vue&type=script&lang=js&"
export * from "./MessageListAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports